import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DateUtils, StringUtils } from '../utils';
import '../css/FrontDesk.css';
import config from '../config';
import io from 'socket.io-client';

import { Routes as routes } from '../navigation';
import { UserActions, NavigationActions, EmgActions, ContextActions, PracticeActions, ConsultationsActions } from '../actions';
import { TitleBar, Button, NavBar, LinkedPractices, PracticeProfile, ConsultationsResolved, ConsultationsActive, StartConsultation, Input } from  '../components'

class EmgHomeScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      invite_client_phone: '',
      invite_client_name: '',
      cancelled_display_count: 5,
      completed_display_count: 5,
      left_display_count: 5,
      errorText: '',
    }
    this.socket = null;
  }

  componentWillUnmount() {
    this.socket.emit('end');
  }

  componentDidMount() {
    this.socket = io(config.NOTIF_URL, { path: '/notifications', query: `notification=VEG` });
    this.socket.on('VEG', (notification) => {
      if (notification.instantSession) {
        let updatedSession = notification.instantSession;
        if (updatedSession) {
          this.props.emgActions.updateSession(notification.instantSession);
        }
      }
    });

    const token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    if (token) {
      this.props.emgActions.getAllInstantSessions(token);
    }
  }

  renderInviteClientSection = () => {
    return <div className="basic-container">
      <h4 style={{ marginBottom: 20 }}>Invite Client</h4>
        <div className='flex-container-row' style={{ justifyContent: 'space-between' }}>
          <div className='flex-container-row'>
            <Input  value={StringUtils.sentenceCase(this.state.invite_client_name)}
                    placeholder="Client Name (optional)"
                    style={{ marginBottom: 10, marginRight: 20 }}
                    onChange={ (event) => { this.setState({ ...this.state, invite_client_name: event.target.value }) }}
                  />
            <Input  value={StringUtils.sentenceCase(this.state.invite_client_phone)}
                    placeholder="Client Phone Number"
                    type='number'
                    style={{ marginBottom: 10, marginRight: 20 }}
                    onChange={ (event) => { this.setState({ ...this.state, invite_client_phone: event.target.value, errorText: '' }) }}
                  />
          </div>
          <div className='flex-container-row'>
            <Button value="Send Invite"
                    style={{ marginRight: 5 }}
                    onClick={ () => {
                      const token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
                      const client_name  = this.state.invite_client_name;
                      const client_phone = this.state.invite_client_phone;
                      if (token && client_phone) {
                        this.props.emgActions.createInstantSessionAndSendInvite(token, client_phone, client_name, this.inviteSuccessAction, this.inviteErrorAction);
                      }
                    }}
                  />
          </div>
        </div>
        { this.state.errorText ?  <div style={{ marginTop: 5 }}>
          <span style={{ color: 'red', fontSize: 14 }}>{ this.state.errorText }</span>
        </div>
        : null }
    </div>
  }

  renderInvitedClientsSection = (sessions) => {
    let noSessions   = sessions.length === 0 ? true : false;
    let sessionRows  = sessions.map((session, index) => {
      let client_name  = session.client_name || 'No Name Provided';
      let client_phone = StringUtils.displayPhoneNumber(session.client_phone);
      let invited_time = DateUtils.getShortMonth(session.created_at) + ' ' + DateUtils.getDateNumber(session.created_at) + ', ' + DateUtils.getTime(session.created_at);
      let displayline  = sessions.length !== index + 1;
      return <div className='flex-container-column' key={session._id}>
        <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <div className='flex-container-column' style={{ flex: 2 }}>
            <span style={{ fontSize: 15, color: 'grey' }}>{ client_name }</span>
            <span style={{ marginTop: -3, fontSize: 13, color: '#1dc2ff' }}>{ client_phone }</span>
          </div>
          <div className='flex-container-column' style={{ flex: 1 }}>
            <span style={{ fontSize: 13, color: 'grey' }}>{ invited_time }</span>
            <span style={{ marginTop: -3, fontSize: 13, color: '#1dc2ff' }}>{ 'Invited At' }</span>
          </div>
          <div className='flex-container-row' style={{ flex: 0.5, justifyContent: 'center' }}>
            <Button value="Cancel"
                    className='button-clear-blue'
                    onClick={ () => {
                      const token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
                      if (token) {
                        this.props.emgActions.cancelInvite(token, session);
                      }
                    }}
                  />
          </div>
        </div>
        { displayline ? <div style={{ height: 1, backgroundColor: '#e7e7e7', marginTop: 8, marginBottom: 8 }}></div> : null }
      </div>
    }).filter((row) => { return row });

    return <div className="basic-container">
      <h4 style={{ marginBottom: 20 }}>Invited Clients</h4>
      { sessionRows }
      { noSessions ? <div style={{ fontSize: 14, color: 'grey', textAlign: 'center', marginBottom: 10 }}>There are no Invited Clients</div> : null }
    </div>
  }

  renderCancelledInvitesSection = (sessions) => {

    let noSessions     = sessions.length === 0 ? true : false;
    let displaySeeMore = sessions.length > this.state.cancelled_display_count ? true : false;

    let sessionRows  = sessions.map((session, index) => {
      let client_name  = session.client_name || 'No Name Provided';
      let client_phone = StringUtils.displayPhoneNumber(session.client_phone);
      let invited_time = DateUtils.getShortMonth(session.created_at) + ' ' + DateUtils.getDateNumber(session.created_at) + ', ' + DateUtils.getTime(session.created_at);
      let displayline  = sessions.length !== index + 1;
      if (index + 1 <= this.state.cancelled_display_count) {
        return <div className='flex-container-column' key={session._id}>
          <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <div className='flex-container-column' style={{ flex: 2 }}>
              <span style={{ fontSize: 15, color: 'grey' }}>{ client_name }</span>
              <span style={{ marginTop: -3, fontSize: 13, color: '#1dc2ff' }}>{ client_phone }</span>
            </div>
            <div className='flex-container-column' style={{ flex: 1 }}>
              <span style={{ fontSize: 13, color: 'grey' }}>{ invited_time }</span>
              <span style={{ marginTop: -3, fontSize: 13, color: '#1dc2ff' }}>{ 'Invited At' }</span>
            </div>
            <div className='flex-container-row' style={{ flex: 0.5, justifyContent: 'center' }}>
              <span style={{ color: 'grey', fontSize: 14 }}>Cancelled</span>
            </div>
          </div>
          { displayline ? <div style={{ height: 1, backgroundColor: '#e7e7e7', marginTop: 8, marginBottom: 8 }}></div> : null }
        </div>
      }
    }).filter((row) => { return row });

    if (displaySeeMore) {
      sessionRows.push(<div className='flex-container-column' style={{ alignItems: 'flex-end' }} key='seeMore'>
          <Button value="See More"
                  style={{ marginTop: 5 }}
                  onClick={ () => {
                    this.setState({ ...this.state, cancelled_display_count: this.state.cancelled_display_count + 10 });
                  }}
                />
        </div>)
    }

    return <div className="basic-container">
      <h4 style={{ marginBottom: 20 }}>Cancelled Invites</h4>
      { sessionRows }
      { noSessions ? <div style={{ fontSize: 14, color: 'grey', textAlign: 'center', marginBottom: 10 }}>There are no Cancelled Invites</div> : null }
    </div>
  }

  renderConnectedSection = (waitingSessions, inProgressSessions) => {

    let noSessions  = waitingSessions.length === 0 && inProgressSessions.length === 0 ? true : false;

    let waitingRows = waitingSessions.map((session, index) => {
      let client_name  = session.client_name || 'No Name Provided';
      let client_phone = StringUtils.displayPhoneNumber(session.client_phone);
      let provider_name= session.provider_name || '';
      let status       = this.statusLabel(session.status);
      let providerCode = session.provider_code.toUpperCase();
      let displayline  = waitingSessions.length !== index + 1 || inProgressSessions.length > 0;
      return <div className='flex-container-column' key={session._id}>
        <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <div className='flex-container-row' style={{ flex: 1 }}>
            <div className='flex-container-column' style={{ flex: 1 }}>
              <span style={{ fontSize: 15, color: 'grey' }}>{ client_name }</span>
              <span style={{ marginTop: -3, fontSize: 13, color: '#1dc2ff' }}>{ client_phone }</span>
            </div>
            { provider_name ? <div className='flex-container-column' style={{ flex: 1 }}>
                <span style={{ fontSize: 15, color: '#1dc2ff' }}>{ provider_name }</span>
                <span style={{ marginTop: -3, fontSize: 13, color: 'grey' }}>{ 'Provider' }</span>
              </div> : null }
          </div>
          <div className='flex-container-column' style={{ flex: 0.27 }}>
            <span style={{ fontSize: 14, color: 'orange' }}>{ status }</span>
            <span style={{ marginTop: -3, fontSize: 13, color: 'grey' }}>Status</span>
          </div>
          <div className='flex-container-column' style={{ flex: 0.27, paddingLeft: 15 }}>
            <span style={{ fontSize: 15, color: '#1dc2ff' }}>{ providerCode }</span>
            <span style={{ marginTop: -3, fontSize: 13, color: 'grey' }}>Code</span>
          </div>
          <div className='flex-conatiner-row'>
            <a className='button-default' href={ config.FRONT_END_URL + '/i_s/' + providerCode } target='_blank'>Join</a>
            <Button value="End"
                    style={{ backgroundColor: 'red', marginLeft: 5 }}
                    onClick={ () => {
                      const token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
                      if (token) {
                        this.props.emgActions.endSessionComplete(token, session);
                      }
                    }}
                  />
          </div>
        </div>
        { displayline ? <div style={{ height: 1, backgroundColor: '#e7e7e7', marginTop: 8, marginBottom: 8 }}></div> : null }
      </div>
    }).filter((row) => { return row });


    let inProgressRows = inProgressSessions.map((session, index) => {
      let client_name  = session.client_name || 'No Name Provided';
      let provider_name= session.provider_name || '';
      let client_phone = StringUtils.displayPhoneNumber(session.client_phone);
      let status       = this.statusLabel(session.status);
      let providerCode = session.provider_code.toUpperCase();
      let displayline  = inProgressSessions.length !== index + 1;
      return <div className='flex-container-column' key={session._id}>
        <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <div className='flex-container-row' style={{ flex: 1 }}>
            <div className='flex-container-column' style={{ flex: 1 }}>
              <span style={{ fontSize: 15, color: 'grey' }}>{ client_name }</span>
              <span style={{ marginTop: -3, fontSize: 13, color: '#1dc2ff' }}>{ client_phone }</span>
            </div>
            { provider_name ? <div className='flex-container-column' style={{ flex: 1 }}>
                <span style={{ fontSize: 15, color: 'grey' }}>{ provider_name }</span>
                <span style={{ marginTop: -3, fontSize: 13, color: '#1dc2ff' }}>{ 'Provider' }</span>
              </div> : null }
          </div>
          <div className='flex-container-column' style={{ width: 73 }}>
            <span style={{ fontSize: 14, color: '#66CE77' }}>{ 'In Progress' }</span>
            <span style={{ marginTop: -3, fontSize: 13, color: 'grey' }}>Status</span>
          </div>
          <div className='flex-container-column' style={{ flex: 0.27, paddingLeft: 15 }}>
            <span style={{ fontSize: 15, color: '#1dc2ff' }}>{ providerCode }</span>
            <span style={{ marginTop: -3, fontSize: 13, color: 'grey' }}>Code</span>
          </div>
          <div className='flex-conatiner-row'>
            <a className='button-default' href={ config.FRONT_END_URL + '/i_s/' + providerCode } target='_blank'>Join</a>
            <Button value="End"
                    style={{ backgroundColor: 'red', marginLeft: 5 }}
                    onClick={ () => {
                      const token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
                      if (token) {
                        this.props.emgActions.endSessionComplete(token, session);
                      }
                    }}
                  />
          </div>
        </div>
        { displayline ? <div style={{ height: 1, backgroundColor: '#e7e7e7', marginTop: 8, marginBottom: 8 }}></div> : null }
      </div>
    }).filter((row) => { return row });

    return <div className="basic-container">
      <h4 style={{ marginBottom: 20 }}>Connected Sessions</h4>
      { noSessions ? null : waitingRows }
      { noSessions ? null : inProgressRows }
      { noSessions ? <div style={{ fontSize: 14, color: 'grey', textAlign: 'center', marginBottom: 10 }}>There are no Connected Sessions</div> : null }
    </div>
  }

  renderLeftSection = (sessions) => {
    let noSessions   = sessions.length === 0 ? true : false;
    let displaySeeMore = sessions.length > this.state.left_display_count ? true : false;

    let sessionRows  = sessions.map((session, index) => {
      let client_name  = session.client_name || 'No Name Provided';
      let client_phone = StringUtils.displayPhoneNumber(session.client_phone);
      let displayline  = sessions.length !== index + 1;
      if (index + 1 <= this.state.left_display_count) {
      return <div className='flex-container-column' key={session._id}>
          <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <div className='flex-container-column'>
              <span style={{ fontSize: 15, color: 'grey' }}>{ client_name }</span>
              <span style={{ marginTop: -3, fontSize: 15, color: '#1dc2ff' }}>{ client_phone }</span>
            </div>
            <div>
              <span style={{ color: 'grey', fontSize: 14, marginRight: 10 }}>Client left session before Provider joined</span>
              { /* <Button value="Completed"
                      style={{ marginRight: 5 }}
                      onClick={ () => {
                        const token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
                        if (token) {
                          this.props.emgActions.endSessionComplete(token, session);
                        }
                      }}
                    /> */ }
            </div>
          </div>
          { displayline ? <div style={{ height: 1, backgroundColor: '#e7e7e7', marginTop: 8, marginBottom: 8 }}></div> : null }
        </div>
      }
    }).filter((row) => { return row });

    if (displaySeeMore) {
      sessionRows.push(<div className='flex-container-column' style={{ alignItems: 'flex-end' }} key='seeMore'>
          <Button value="See More"
                  style={{ marginTop: 5 }}
                  onClick={ () => {
                    this.setState({ ...this.state, left_display_count: this.state.left_display_count + 10 });
                  }}
                />
        </div>)
    }

    return <div className="basic-container">
      <h4 style={{ marginBottom: 20 }}>Left Sessions</h4>
      { sessionRows }
      { noSessions ? <div style={{ fontSize: 14, color: 'grey', textAlign: 'center', marginBottom: 10 }}>There are no Left Sessions</div> : null }
    </div>
  }

  renderCompletedSection = (sessions) => {
    let noSessions   = sessions.length === 0 ? true : false;
    let displaySeeMore = sessions.length > this.state.completed_display_count ? true : false;

    let sessionRows  = sessions.map((session, index) => {
      let client_name  = session.client_name || 'No Name Provided';
      let client_phone = StringUtils.displayPhoneNumber(session.client_phone);
      let completed_time = DateUtils.getShortMonth(session.updated_at) + ' ' + DateUtils.getDateNumber(session.updated_at) + ', ' + DateUtils.getTime(session.updated_at);
      let displayline  = sessions.length !== index + 1;
      if (index + 1 <= this.state.completed_display_count) {
        return <div className='flex-container-column' key={session._id}>
          <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <div className='flex-container-column'>
              <span style={{ fontSize: 15, color: 'grey' }}>{ client_name }</span>
              <span style={{ marginTop: -3, fontSize: 15, color: '#1dc2ff' }}>{ client_phone }</span>
            </div>
            <div className='flex-container-column' style={{ alignItems: 'flex-end' }}>
              <span style={{ fontSize: 14, color: 'grey' }}>{ completed_time }</span>
              <span style={{ marginTop: -3, fontSize: 14, color: '#1dc2ff' }}>{ 'Completed Time' }</span>
            </div>
          </div>
          { displayline ? <div style={{ height: 1, backgroundColor: '#e7e7e7', marginTop: 8, marginBottom: 8 }}></div> : null }
        </div>
      }
    }).filter((row) => { return row });

    if (displaySeeMore) {
      sessionRows.push(<div className='flex-container-column' style={{ alignItems: 'flex-end' }} key='seeMore'>
          <Button value="See More"
                  style={{ marginTop: 5 }}
                  onClick={ () => {
                    this.setState({ ...this.state, completed_display_count: this.state.completed_display_count + 10 });
                  }}
                />
        </div>)
    }

    return <div className="basic-container">
      <h4 style={{ marginBottom: 20 }}>Completed Sessions</h4>
      { noSessions ? null : sessionRows }
      { noSessions ? <div style={{ fontSize: 14, color: 'grey', textAlign: 'center', marginBottom: 10 }}>There are no Completed Sessions</div> : null }
    </div>
  }

  renderEmgHomeScreen = () => {

    const sessionsDict     = this.props.emg.sessionsStatusDict || {};
    const invitedClients   = sessionsDict['INVITED'] || [];
    const cancelledInvites = sessionsDict['CANCELLED'] || [];
    const waitingSessions  = sessionsDict['WAITING'] || [];
    const inProgressSeshs  = sessionsDict['IN_PROGRESS'] || [];
    const completedSeshs   = sessionsDict['COMPLETED'] || [];
    const leftSeshs        = sessionsDict['LEFT'] || [];

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        { this.renderInviteClientSection() }
        { this.renderInvitedClientsSection(invitedClients) }
        { /* this.renderCancelledInvitesSection(cancelledInvites) */ }
      </div>
      <div className="screen-container-column">
        { this.renderConnectedSection(waitingSessions, inProgressSeshs) }
        { /* this.renderLeftSection(leftSeshs) */ }
        { /* this.renderCompletedSection(completedSeshs) */ }
      </div>
    </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          practice={this.props.practice.practice}
          userActions={this.props.userActions}
        />

        { this.renderEmgHomeScreen() }

      </div>
    );
  }

  inviteSuccessAction = () => {
    this.setState({
      ...this.state,
      invite_client_phone: '',
      invite_client_name: '',
      errorText: '',
    })
  }

  inviteErrorAction = (error) => {
    this.setState({
      ...this.state,
      errorText: error.toString(),
    })
  }

  statusLabel = (status) => {
    const statusDict = {
      'INVITED': 'Invited',
      'WAITING': 'Waiting',
      'IN_PROGRESS': 'In Progress',
      'COMPLETED': 'Completed',
      'LEFT': 'Left',
      'CANCELLED': 'Cancelled',
    }
    return statusDict[status];
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    consultations: state.consultations,
    context: state.context,
    emg: state.emg,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    consultationsActions: bindActionCreators(
     { ...ConsultationsActions }, dispatch),
    emgActions: bindActionCreators(
     { ...EmgActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmgHomeScreen)
